<!--认证页-->
<template>
  <div class="content-approve">
    <p class="title-b">认证申请<span class="titleTips">认证后可进行产品试用，正式授权认证后可永久使用。</span></p>
    <p class="line-gray"></p>

    <div :class="['approveStateCon', stateClass]">
      <span class="result">{{resultText}}</span>
      <span class="cause">{{causeText}}</span>

      <span class="passBtnCon">
        <a href="javascript:;" class="passBtnCom directly" @click="goToUse">立即试用</a>
        <a href="javascript:;" class="passBtnCom apply" @click="applyFormal">申请正式授权</a>
      </span>

    </div>

    <div class="top-nav">
      <div
        :class="['top-nav-item', 'nav-left', curStep == 0 ? 'curStep': '', curStep > 0 ? 'finish': '']">
        <p class="nav"></p>
        <p class="navTitle">认证资料提交</p>
      </div>
      <div :class="['top-nav-item', curStep == 1 ? 'curStep': '', curStep > 1 ? 'finish': '']">
        <p class="nav"></p>
        <p class="navTitle">认证审核</p>
      </div>
      <div :class="['top-nav-item', curStep == 2 ? 'curStep': '', curStep > 2 ? 'finish': '']">
        <p class="nav"></p>
        <p class="navTitle">产品试用</p>
      </div>
      <div :class="['top-nav-item', curStep == 3 ? 'curStep': '', curStep > 3 ? 'finish': '']">
        <p class="nav"></p>
        <p class="navTitle">正式授权申请</p>
      </div>
      <div
        :class="['top-nav-item', 'nav-right', curStep == 4 ? 'curStep': '', curStep > 4 ? 'finish': '']">
        <p class="nav"></p>
        <p class="navTitle">正式授权</p>
      </div>

      <div class="explain">
        <p class="explainText">上传与协同软件签订的合同后无需试用，可直接正式授权</p>
      </div>
    </div>

    <!--认证资料提交-->
    <DataCommit v-if="curStep == 0" :common="common"></DataCommit>
    <!--认证审核-->
    <ApproveVerify v-else-if="curStep == 1" :common="common"></ApproveVerify>
    <!--产品试用-->
    <ProductTrial v-else-if="curStep == 2" :common="common"></ProductTrial>
    <!--正式授权申请-->
    <PermRequest v-else-if="curStep == 3" :common="common"></PermRequest>
    <!--正式授权-->
    <Authorize v-else-if="curStep == 4" :common="common"></Authorize>

  </div>
</template>

<script>
  import DataCommit from './DataCommit'
  import ApproveVerify from './ApproveVerify'
  import ProductTrial from './ProductTrial'
  import PermRequest from './PermRequest'
  import Authorize from './Authorize'
  import Base64 from '@/utils/base64'

  export default {
    name: 'Approve'
    , data () {
      return {
        // 当前步骤
        curStep: -1
        , common: {
          step: 0
          , result: Object
          , resultbg: []
        }
        // 认证结果
        , resultText: ''
        // 原因
        , causeText: ''
        , stateClass: 'none'
      }
    }
    , methods: {
      // 网络获取数据
      getDataFromUrl () {
        let params = {
          nsrsbh: this.$store.getters.getNsrsbh
        }
        this.$axios.post('UserManager/GetALLRenZhengStatus', params)
          .then((res) => {
            let data = res.data
            if (data.isError == 'false') {
              let result = data.result[0]
                , resultbg = data.resultbg.ds

              this.common.result = result
              this.common.resultbg = resultbg

              if (result.rzzt == 0) { // 未开始进行申请
                this.stateClass = 'none'
                this.curStep = 0
              }
              if (result.rzzt == 1) { // 申请状态为1 为正在申请中
                this.stateClass = 'ing'
                if (result.sqlx == 0) { // 试用
                  this.curStep = 1
                  this.resultText = '产品试用审核中...'
                } else if (result.rzsf == '试用用户') { // 还有一种试用身份然后继续进行正式授权申请状态
                  this.curStep = 4
                  this.resultText = '正式授权审核中...'
                } else {
                  this.curStep = 1
                  this.resultText = '正式授权审核中...'
                }
              }
              if (result.rzzt == 2 && result.sqlx == 0) { // 为2 认证通过 试用
                this.curStep = 2
                // 判断下试用时间
                if (result.yxsj == '永久') {
                  this.stateClass = 'pass'
                  this.resultText = '您的试用申请已通过！'
                  this.causeText = '剩余试用时间：永久'
                } else if (Number(result.yxsj) <= 0) {
                  this.stateClass = 'ed'
                  this.resultText = '您的试用期限已到！'
                  this.causeText = '请申请正式授权'
                } else {
                  this.stateClass = 'pass'
                  this.resultText = '您的试用申请已通过！'
                  this.causeText = '剩余试用时间：' + result.yxsj + '天'
                }
              }
              if (result.rzzt == 2 && result.sqlx == 1) { // 为2 认证通过 正式
                // this.curStep = 2
                // 直接进系统
                window.location.href = '/'
                // this.$router.push({
                //   path: '/'
                // })
              }

              // 未通过
              if (result.rzzt == 3) {
                this.curStep = 0
                this.stateClass = 'not'
                if (result.sqlx == 0) { // 试用
                  this.resultText = '您的产品试用申请未通过！'
                } else {
                  this.resultText = '您的正式授权申请未通过！'
                }
                this.causeText = '未通过原因：' + result.bz
              }
            } else {
              this.curStep = 0
              this.stateClass = 'none'
            }
          })
          .catch((err) => {
            this.$message({
              message: '认证状态请求失败!请刷新重试'
              , type: 'warning'
            })
          })
      }
      // 申请正式
      , applyFormal () {
        this.common.applyDialogFunc()
      }
      // 立即试用
      , goToUse () {
        window.location.href = '/User/Index'
      }
    }
    , created () {
      // console.log(this.$route, this.$utils.getQueryString(this.$route.fullPath.split('?')[1], 'nsrsbh')
      //   , Base64.base64decode(this.$route.fullPath.split('?')[1])
      // )
      // 进入请求状态
      let path = this.$route.fullPath.split('?')[1]
        , nsrsbh = this.$utils.getQueryString(path, 'nsrsbh')
        , userName = this.$utils.getQueryString(path, 'username')
      if (userName != null) {
        // 设置全局变量
        this.$store.commit('setUserName', userName)
        this.$store.commit('setNsrsbh', nsrsbh)

        this.getDataFromUrl()
      } else {
        this.curStep = 0
      }
      this.common.getDataCallback = this.getDataFromUrl
    }
    , watch: {
      'common.step': function (value) {
        this.curStep = value
      }
      // // 测试用
      // , curStep (value) {
      //   if (value == 2) {
      //     this.stateClass = 'pass'
      //   }
      // }
    }
    , components: {
      DataCommit
      , ApproveVerify
      , ProductTrial
      , PermRequest
      , Authorize
    }
  }
</script>

<style scoped src="../css/reset.css"></style>
<style scoped>
  .content-approve {
    width: 100%;
    height: auto;
    min-height: calc(100% - 253px);
    max-width: 1200px;
    box-sizing: border-box;
    margin: 8px auto;
    background: #ffffff;
    overflow: hidden;
  }

  .title-b {
    font-size: 24px;
    color: #2E2E2E;
    letter-spacing: 0;
    margin: 19px 0 12px 44px !important;
  }

  .title-b:before {
    content: '';
    position: relative;
    display: inline-block;
    font-size: 0;
    width: 6px;
    height: 20px;
    top: 2px;
    left: 0;
    margin-right: 13px;
    background: #04A4FF;
  }

  .line-gray {
    height: 1px;
    background: #EDEDED;
    margin: 0 24px;
  }

  .titleTips {
    font-size: 12px;
    color: #F55A23;
    margin-left: 23px;
    text-align: end;
  }

  .top-nav {
    position: relative;
    width: 800px;
    height: 169px;
    margin: 0 auto;
    border-bottom: 1px solid #EDEDED;
  }

  .top-nav:before {
    position: absolute;
    display: block;
    content: '';
    background: #D7D8DC;
    height: 1px;
    width: 700px;
    top: 89px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .top-nav-item {
    position: relative;
    display: inline-block;
    height: 100%;
    width: 170px;
  }

  .nav {
    display: block;
    width: 51px;
    height: 33px;
    margin: 72px auto 0;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #fff;
  }

  .top-nav .top-nav-item:nth-child(1) .nav {
    background-image: url("../assets/nav1_on.png");
  }

  .top-nav .top-nav-item:nth-child(2) .nav {
    background-image: url("../assets/nav2_un.png");
  }

  .top-nav .top-nav-item:nth-child(3) .nav {
    background-image: url("../assets/nav3_un.png");
  }

  .top-nav .top-nav-item:nth-child(4) .nav {
    background-image: url("../assets/nav4_un.png");
  }

  .top-nav .top-nav-item:nth-child(5) .nav {
    background-image: url("../assets/nav5_un.png");
  }

  .top-nav .top-nav-item:nth-child(2)[class~="curStep"] .nav {
    background-image: url("../assets/nav2_on.png");
  }

  .top-nav .top-nav-item:nth-child(3)[class~="curStep"] .nav {
    background-image: url("../assets/nav3_on.png");
  }

  .top-nav .top-nav-item:nth-child(4)[class~="curStep"] .nav {
    background-image: url("../assets/nav4_on.png");
  }

  .top-nav .top-nav-item:nth-child(5)[class~="curStep"] .nav {
    background-image: url("../assets/nav5_on.png");
  }


  .navTitle {
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #000000;
    margin-top: 13px;
    text-align: center;
  }

  .nav-left {
    width: 145px;
  }

  .nav-left .nav {
    margin-left: 34px;
  }

  .nav-left .navTitle {
    text-align: left;
    padding-left: 18px;
  }

  .nav-right {
    width: 145px;
  }

  .nav-right .nav {
    margin-right: 34px;
  }

  .nav-right .navTitle {
    padding-left: 13px;
  }

  .curStep .navTitle {
    font-weight: 600;
  }

  .finish {

  }

  .finish .nav {
    background-image: url("../assets/nav_finish.png") !important;
  }

  .explain {
    position: absolute;
    width: 349px;
    height: 48px;
    border: 1px solid #D7D8DC;
    border-radius: 4px;
    border-bottom: none;
    top: 41px;
    right: 140px;
    z-index: 0;
    overflow: visible;
  }

  .explainText {
    width: 325px;
    height: 24px;
    line-height: 24px;
    background: #FFFFFF;
    border: 1px solid #C9C9C9;
    border-radius: 12px;
    font-size: 12px;
    color: #3D5570;
    letter-spacing: 0.3px;
    text-align: center;
    margin: -12px 13px 0;
  }

  .content-approve >>> .container {
    padding-bottom: 72px;
  }

  .container >>> .labelStyle {
    width: 417px;
  }

  .container >>> .marginCon {
    height: 26px;
    position: relative;
    padding-top: 10px;
    font-size: 14px;;
    line-height: 26px;
  }

  .container >>> .labelTitle {
    display: inline-block;
    width: 417px;
    color: #000000;
    text-align: right;
  }

  .container >>> .redReq {
    font-size: 14px;
    color: #FF4D4D;
    letter-spacing: 0;
  }

  .container >>> .fileCon {
    display: inline-block;
    min-height: 164px;
    box-sizing: border-box;
    width: 597px;
    border: 1px solid #DFDFDF;
    padding: 5px;
  }

  .approveStateCon {
    position: relative;
    height: 72px;
    line-height: 72px;
    box-sizing: border-box;
    margin: 14px 100px 0;
    text-align: center;
    font-size: 16px;
  }

  .result {
    font-weight: 600;
  }

  /*未通过*/
  .not {
    background: #FFF9EF;
    border: 1px solid #FFCAAB;
    border-radius: 4px;
  }

  .not .result {
    color: #ED2222;
  }

  .not .cause {
    color: #845151;
  }

  .not .passBtnCon {
    display: none;
  }

  /*过期*/
  .ed {
    position: relative;
    background: #FFF9EF;
    border: 1px solid #FFCAAB;
    border-radius: 4px;
    text-align: left;
  }

  .ed .result {
    color: #ED2222;
    margin-left: 149px;
  }

  .ed .cause {
    color: #845151;
  }

  .ed .directly {
    display: none;
  }

  .ed .passBtnCon {
    right: 240px;
  }

  /*申请中*/
  .ing {
    background: #F6FCFF;
    border: 1px solid #2BD3EC;
    border-radius: 4px;
  }

  .ing .result {
    color: #4B4B4B;
  }

  .ing .cause {
    display: none;
  }

  .ing .passBtnCon {
    display: none;
  }

  /*通过*/
  .pass {
    position: relative;
    background: #F6FFF6;
    border: 1px solid #7DDA17;
    border-radius: 4px;
    text-align: left;
  }

  .pass .result {
    color: #309D05;
    margin-left: 149px;
  }

  .pass .cause {
    color: #417505;
  }

  .passBtnCon {
    display: inline-block;
    position: absolute;
    right: 149px;
    top: 0;
  }

  .passBtnCom {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    text-decoration: none;
    font-weight: 600;
  }

  .directly {
    width: 120px;
    background: #3492FF;
  }

  .apply {
    width: 140px;
    background: #F5A623;
    margin-left: 32px;

  }

  p, div, input {
    overflow: hidden;
    transition: all .3s;
  }
</style>



// WEBPACK FOOTER //
// src/page/Approve.vue